import { Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

import { getBrandCustom } from "../../../util/getCustomColor";
import { Button } from "../../Form";
import Modal from "../../Generic/Modal";

const GRAY600 = "#475467";

export const GeneralCommentsModalWrapper = styled(Modal)(() => ({
  maxWidth: "760px",
}));

export const ModalText = styled("p")(() => ({
  color: "#232325",
  fontSize: 16,
  fontWeight: 400,
  lineHeight: "150%",
  fontFamily: "Inter",
}));

export const DeleteText = styled("p")(() => ({
  fontWeight: 400,
  fontSize: 16,
  lineHeight: "150%",
  color: "#F04438",
  fontStyle: "italic",
  fontFamily: "Inter",
}));

export const CommentsTitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "24px",
  color: colors.gray600,
}));

export const NewCommentButton = styled(Button, {
  shouldForwardProp(propName) {
    return propName !== "isEmpty";
  },
})<{
  isEmpty?: boolean;
}>(({ isEmpty = false }) => ({
  backgroundColor: `${getBrandCustom("primaryColor", colors.brandBlue500)} !important`,
  color: "#FFFFFF !important",

  "@media screen and (max-width: 768px)": {
    "&.MuiButton-root": {
      minWidth: isEmpty ? 40 : 36,
      height: isEmpty ? 40 : 36,
      padding: isEmpty ? "9 16" : 4,
    },
  },

  "& span.MuiButton-startIcon": {
    "@media screen and (max-width: 768px)": {
      marginRight: isEmpty ? 8 : 0,
    },
  },
}));

export const ButtonLabel = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: 0.1,
  "@media screen and (max-width: 768px)": {
    display: "none",
  },
}));

export const EmptyCommentsTitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 500,
  fontSize: "24px",
  lineHeight: "32px",
  color: GRAY600,
}));

export const CommentsWrapper = styled("div")(() => ({
  marginTop: 16,
  marginBottom: 16,
}));

export const CommentsTitleContainer = styled(Grid)(() => ({
  marginBottom: "16px",
}));

export const EmptyState = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "24px",
}));

export const EmptyStateWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  maxWidth: "432px",
  flexDirection: "column",
  textAlign: "center",
  gap: "4px",
}));

export const EmptyCommentMessage = styled("span")(() => ({
  font: "400 14px/24px Manrope",
  color: GRAY600,
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const EmptyCommentViewMessage = styled("span")(() => ({
  font: "400 16px Manrope",
  color: colors.gray600,
}));

export const useStyles = makeStyles(() => ({
  skeleton: {
    height: "167px",
  },
  modal: {
    "@media screen and (min-width: 768px)": {
      width: "520px !important",
    },
  },
}));
